module.exports = __webpack_public_path__ + "static/img/cd-logo.aff4e20f.png";